module.exports = __webpack_public_path__ + "img/ic_user_inactive.5e8c2fad.svg";